<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-select
								size="small"
								style="margin-right: 10px;width: 120px !important;" 
								v-model="getdata.year" placeholder="请选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="item"
									v-for="item in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
							<el-select
								size="small"
								style="width: 120px !important;margin-right: 10px;" 
								v-model="getdata.month" placeholder="请选择月份"
								clearable
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									:key="item"
									v-for="item in $monthList()"
									:label="item+'月'"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" 
							v-if="getdata.user_id == $store.state.user.userinfo.id"
							@click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" @click="addZx">新增</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="true"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Index from './mixins/index.js'
	export default {
		mixins:[Index]
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}
</style>

